module.exports = __webpack_public_path__ + "static/media/banner1.43768367.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/gressel/images/banner1.png
// module id = 542
// module chunks = 0